// Punto de entrada global; cada task añade su init aquí.
window.USAD = window.USAD || {};

// El hero se mete DEBAJO del header (transparente) con un margin negativo de
// --header-h. Cuando esa constante se queda corta respecto al header real,
// asoma una franja negra sobre la foto — ya pasó al crecer los pills del header
// a 50px. Aquí se mide el header de verdad y se escribe la variable, así deja
// de haber dos números que mantener sincronizados a mano. El valor de
// tokens.css sigue siendo el del primer render (antes de que corra este JS).
(function syncHeaderHeight() {
  var header = document.querySelector('.site-header');
  if (!header) return;
  var apply = function () {
    document.documentElement.style.setProperty('--header-h', Math.round(header.getBoundingClientRect().height) + 'px');
  };
  apply();
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(apply).observe(header);
  } else {
    window.addEventListener('resize', apply);
  }
})();

// Utilidad compartida — Task 13 (predictive search) necesita formatear
// dinero client-side sin pasar por el filtro `| money` de Liquid (corre
// después de un fetch, sin re-render server-side). Extraída a
// `window.USAD.formatMoney` para no quedar acoplada a un solo caller.
// Task 11 (PDP variant picker) la usaba también hasta Task 4 (23-ago): con
// el catálogo de 1 sola variante por producto ya no hay picker que
// resolver client-side, así que ese consumidor se eliminó — el selector de
// paquetes (más abajo) calcula el total con un `money()` local propio, sin
// depender de esta utilidad (mismo criterio "sin dependencias" que el
// resto de módulos chicos de este archivo). Cubre los 4 tokens estándar de Shopify
// ({{amount}}, {{amount_no_decimals}}, {{amount_with_comma_separator}},
// {{amount_no_decimals_with_comma_separator}} — mismo comportamiento que
// Shopify.formatMoney de money.js, sin la dependencia completa). Si
// moneyFormat no trae ninguno de los 4 tokens conocidos, cae a reemplazar
// {{amount}} literal o prefijo "$" a secas.
window.USAD.formatMoney = function (cents, moneyFormat) {
  moneyFormat = moneyFormat || '${{amount}}';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var match = moneyFormat.match(placeholderRegex);

  var withDelimiters = function (precision, thousandsSep, decimalSep) {
    var value = (cents / 100).toFixed(precision);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    var decimals = parts[1] ? decimalSep + parts[1] : '';
    return whole + decimals;
  };

  if (match) {
    var formatted;
    switch (match[1]) {
      case 'amount':
        formatted = withDelimiters(2, ',', '.');
        break;
      case 'amount_no_decimals':
        formatted = withDelimiters(0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = withDelimiters(2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = withDelimiters(0, '.', ',');
        break;
    }
    if (formatted !== undefined) {
      return moneyFormat.replace(placeholderRegex, formatted);
    }
  }

  var value = (cents / 100).toFixed(2);
  if (moneyFormat.indexOf('{{amount}}') !== -1) {
    return moneyFormat.replace('{{amount}}', value);
  }
  return '$' + value;
};

// Task 3: header sticky + drawer móvil de navegación.
(function headerAndDrawer() {
  var header = document.querySelector('[data-header]');
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeBtn = drawer ? drawer.querySelector('[data-drawer-close]') : null;

  if (header) {
    var setScrolled = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }

  if (!drawer || !openBtn) return;

  var closing = false;

  var setExpanded = function (value) {
    openBtn.setAttribute('aria-expanded', value ? 'true' : 'false');
  };

  var openDrawer = function () {
    if (typeof drawer.showModal === 'function') {
      drawer.showModal();
    } else {
      drawer.setAttribute('open', '');
    }
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
    });
    setExpanded(true);
  };

  var finishClose = function () {
    closing = false;
    if (drawer.open) drawer.close();
    // No depender solo del evento nativo 'close' (además de disparar siempre que
    // se cierra por esta vía, actúa como red de seguridad si un futuro script
    // cierra el <dialog> por otro camino).
    drawer.classList.remove('is-open');
    setExpanded(false);
    openBtn.focus();
  };

  var closeDrawer = function () {
    if (!drawer.open) return;
    if (closing) return;
    if (!drawer.classList.contains('is-open')) {
      finishClose();
      return;
    }
    closing = true;
    drawer.classList.remove('is-open');
    var onEnd = function (event) {
      if (event.target !== drawer) return;
      drawer.removeEventListener('transitionend', onEnd);
      finishClose();
    };
    drawer.addEventListener('transitionend', onEnd);
    // Fallback por si transitionend no dispara (reduced motion, etc.)
    setTimeout(function () {
      drawer.removeEventListener('transitionend', onEnd);
      finishClose();
    }, 400);
  };

  openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  // Clic fuera: el clic sobre el ::backdrop nativo llega como clic sobre el <dialog> mismo.
  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) closeDrawer();
  });

  // Escape dispara 'cancel' en el <dialog> nativo antes de cerrarse.
  drawer.addEventListener('cancel', function (event) {
    event.preventDefault();
    closeDrawer();
  });

  // Red de seguridad: si el <dialog> se cierra por una vía que no pasó por
  // closeDrawer()/finishClose() (ej. otro script llama a drawer.close()
  // directamente), igual queda el estado consistente. Las tres líneas son
  // idempotentes frente a finishClose().
  drawer.addEventListener('close', function () {
    drawer.classList.remove('is-open');
    setExpanded(false);
    openBtn.focus();
  });
})();

// La entrada del hero (título, textos, tabla, card) y el parallax de la tabla
// viven ahora en theme/assets/hero-anim.js, que hero.liquid carga junto a GSAP
// y ofrece tres variantes seleccionables. Aquí se quitó la versión de Task 4
// para que no corran dos animaciones sobre los mismos elementos.

// Task 5: shop-categories — tabs por colección, sin fetch (los 4 paneles ya
// están renderizados server-side). JS solo conmuta [hidden] + aria-selected +
// clase is-active. Cada tab es un <button> real: Enter/Space ya funcionan
// nativamente, no hace falta un keydown handler dedicado.
(function shopCategories() {
  document.querySelectorAll('[data-shop-categories]').forEach(function (section) {
    var tabs = section.querySelectorAll('[data-tab]');
    var panels = section.querySelectorAll('[data-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.getAttribute('data-target');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.id === targetId;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  });
})();

// Puntos de paginación del carrusel de "Shop by categories" (nodo 406:4036 del
// máster). La pista es scroll nativo con snap, así que sin JS sigue siendo
// arrastrable: esto solo enlaza los puntos con el scroll en ambos sentidos.
(function shopCategoriesDots() {
  document.querySelectorAll('[data-panel]').forEach(function (panel) {
    var track = panel.querySelector('[data-sc-track]');
    if (!track || track.children.length < 2) return;
    var dots = Array.prototype.slice.call(panel.querySelectorAll('[data-sc-dot]'));

    // ROTACION, no scroll acumulado (25-ago, pedido de Robert). Antes esto
    // empujaba scrollLeft y volvia a 0 al llegar al final, y tenia dos fallos:
    //   · La ultima card se quedaba pegada al borde derecho, justo debajo del
    //     velo de cristal, asi que nunca se llegaba a ver entera.
    //   · Con pocas cards no avanzaba EN ABSOLUTO. En Australian, con 5
    //     productos, el scroll disponible es ~440 y un paso mide 442: la
    //     condicion de reinicio saltaba en el primer tick y volvia a 0 siempre.
    // Ahora cada tick desplaza una card y, al terminar la animacion, mueve esa
    // primera card al final y devuelve el scroll a 0. La posicion es siempre 0,
    // el bucle es continuo y —esto es lo que pidio— toda card acaba pasando por
    // el primer puesto, incluida la que quedaba tapada por el cristal.
    var total = track.children.length;
    var offset = 0;      // cuantas cards se han rotado; 0 = orden original
    var PORPAG = 4;      // los puntos del master paginan de 4 en 4
    // Movil (Bety, 8-sep): el track es un grid de 2 filas paginado por
    // scroll-snap, asi que aqui NO se rota el DOM ni hay avance automatico:
    // los dots leen y mueven el scroll por paginas de ancho completo.
    var MOBILE = window.matchMedia('(max-width: 989px)');

    var paso = function () {
      var a = track.children[0];
      if (!a) return track.clientWidth;
      var b = track.children[1];
      if (!b) return a.getBoundingClientRect().width;
      return b.getBoundingClientRect().left - a.getBoundingClientRect().left;
    };

    var pintarPuntos = function () {
      if (!dots.length) return;
      var cur = Math.floor(offset / PORPAG) % dots.length;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === cur);
        if (i === cur) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    var rotar = function (n) {
      for (var i = 0; i < n; i++) track.appendChild(track.firstElementChild);
      offset = (offset + n) % total;
      // `behavior: 'instant'` y NO `track.scrollLeft = 0`: la pista lleva
      // `scroll-behavior: smooth` en el CSS, que convierte la asignacion en una
      // animacion — y esa animacion se perdia, dejando el scroll clavado donde
      // estaba (medido: 1770 antes, 1770 despues, 1770 a los 800ms). Con
      // 'instant' se sobreescribe la regla del CSS y el salto es inmediato,
      // que es justo lo que hace falta para que la rotacion no se vea.
      track.scrollTo({ left: 0, behavior: 'instant' });
      pintarPuntos();
    };

    var pintarPagina = function (cur) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === cur);
        if (i === cur) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        if (MOBILE.matches) {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
          return;
        }
        // Rota hasta que la primera card sea la que abre esa pagina.
        var objetivo = (i * PORPAG) % total;
        rotar((objetivo - offset + total) % total);
      });
    });
    track.addEventListener('scroll', function () {
      if (!MOBILE.matches || !dots.length || !track.clientWidth) return;
      pintarPagina(Math.round(track.scrollLeft / track.clientWidth) % dots.length);
    }, { passive: true });
    pintarPuntos();

    // Se para en cuatro casos: con prefers-reduced-motion no arranca; con el
    // puntero encima o el foco dentro, para no arrastrar la card que el usuario
    // esta mirando o tabulando; cuando el panel esta oculto (es el de otra
    // categoria); y cuando la seccion no se ve en pantalla.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var paused = false;
    var onScreen = true;

    ['pointerenter', 'focusin'].forEach(function (evt) {
      track.addEventListener(evt, function () { paused = true; });
    });
    ['pointerleave', 'focusout'].forEach(function (evt) {
      track.addEventListener(evt, function () { paused = false; });
    });

    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
      }, { threshold: 0.2 }).observe(track);
    }

    setInterval(function () {
      if (MOBILE.matches) return;
      if (paused || !onScreen) return;
      if (panel.hasAttribute('hidden')) return;
      track.scrollTo({ left: paso(), behavior: 'smooth' });
      // 550ms cubre de sobra la animacion de scroll suave del navegador; al
      // rotar despues, el salto de vuelta a 0 no se ve porque la card que
      // estaba en primer lugar ya salio por la izquierda.
      setTimeout(function () { rotar(1); }, 550);
    }, 3000);
  });
})();

// Task 11: PDP — galería (imagen principal + thumbnails). El catálogo real
// no trae fotos en ningún producto hoy (placeholder SVG en todos), así que
// este bloque solo se ejercita visualmente cuando se suban imágenes — la
// lógica en sí no depende de eso, [data-pdp-thumb] simplemente no existe
// (0 nodos) cuando product.images.size <= 1, forEach sobre NodeList vacía
// no hace nada, sin errores.
(function productGallery() {
  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-pdp-main-img]');
    var thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-current', active ? 'true' : 'false');
        });
        mainImg.src = thumb.getAttribute('data-full');
        mainImg.removeAttribute('srcset');
        mainImg.alt = thumb.getAttribute('data-alt') || '';
      });
    });
  });
})();

// Task 4 (23-ago): PDP — cuántos paquetes -> quantity + total. Reemplaza a
// productVariantPicker()/productQuantity() (theme v1, removidos junto con
// el <select>/pills de variante y el stepper genérico — ver comentario en
// main-product.liquid). Mismo patrón que los módulos de arriba: IIFE +
// document.querySelector, sin dependencias (no usa window.USAD.formatMoney
// a propósito — ver comentario de esa utilidad más arriba).
//
// El contrato (`data-qty-selector`/`data-qty-option`/`data-qty-custom`/
// `data-pdp-total`/`data-pdp-estimate`) lo consume Task 5 sin tocarlo, así
// que no se renombra nada de esto sin avisar.
(function () {
  var root = document.querySelector('[data-qty-selector]');
  if (!root) return;
  var form = root.closest('form');
  var qty = root.querySelector('[data-pdp-quantity]');
  var customWrap = root.querySelector('[data-qty-custom]');
  var customInput = root.querySelector('[data-qty-custom-input]');
  var unitPrice = parseInt(root.dataset.unitPrice, 10); // centavos, precio de UN paquete
  var totalEl = form.querySelector('[data-pdp-total]');
  var estimateEl = form.querySelector('[data-pdp-estimate]');

  // Fix round 1 (Important, revisor): tope duro de paquetes en Custom. Sin
  // esto, un número gigante (ej. pegar "999999999999999999999999999")
  // pierde precisión al convertirse con `Number(...)` (cae en notación
  // científica, ej. `1e+27`) y ese valor roto va a DOS sitios: el total
  // del botón (precio en notación científica, sin sentido) y el input
  // oculto `quantity` que se manda a /cart/add — que Shopify trunca en
  // SILENCIO a 1, sin avisar. 999 es un tope generoso pero finito para
  // ESTA tienda: paquetes de carne pre-cortados/pre-pesados vendidos al
  // por MENOR, no a un mayorista — ni el pedido más grande realista
  // (catering, restaurante) se acerca a esa cifra, y queda muy por debajo
  // de donde arrancaría cualquier problema de precisión de punto flotante
  // en JS (Number.MAX_SAFE_INTEGER ≈ 9 × 10^15). Este clamp LÓGICO sigue
  // igual en el fix round 2 — lo que cambió es que ya no tiene un `max`
  // de HTML espejándolo (ver `customInput.disabled` más abajo, y el
  // comentario de package-selector.liquid, para el porqué).
  var MAX_PACKAGES = 999;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function apply(n) {
    var safe = Math.min(MAX_PACKAGES, Math.max(1, Math.floor(Number(n) || 1)));
    qty.value = safe;
    var total = unitPrice * safe;
    if (totalEl) totalEl.textContent = ' — ' + money(total);
    if (estimateEl) {
      // Con un solo paquete el total ya es el precio grande: no repetirlo.
      estimateEl.textContent = safe > 1 && estimateEl.dataset.template
        ? estimateEl.dataset.template
            .replace('{{ total }}', money(total))
            .replace('{{ count }}', safe)
        : '';
    }
  }

  function clearActive() {
    root.querySelectorAll('[data-qty-option], [data-qty-custom-toggle]').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-pressed', 'false');
    });
  }

  // Fix round 2 (Critical, revisor): `customInput.disabled` se mantiene
  // SIEMPRE en sync con `customWrap.hidden` — nunca uno sin el otro. El
  // input custom ya no lleva min/max/step de HTML (ver comentario grande
  // en package-selector.liquid), pero aunque algún día alguien le agregue
  // una restricción nueva, o el usuario pegue algo que `type="number"` no
  // sepa parsear (`validity.badInput`), `disabled` es la única garantía
  // de spec de que un control queda AFUERA de la validación del form pase
  // lo que pase con su valor. Antes de este fix, el input quedaba
  // `hidden` pero seguía siendo "candidato a validación" — `hidden` NO
  // saca a un control de la validación nativa, así que un valor fuera de
  // rango tecleado minutos antes (y ya invisible) tumbaba el `submit` de
  // CUALQUIER intento posterior, incluido uno con un preset 100% válido
  // seleccionado. cart.js escucha exactamente ese evento `submit` — si el
  // navegador no lo dispara (control inválido en el form, sin importar si
  // tiene `name` o está oculto), no hay fetch, no hay carrito, y no hay
  // ningún error visible para el comprador.
  root.querySelectorAll('[data-qty-option]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      clearActive();
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      customWrap.hidden = true;
      customInput.disabled = true;
      root.querySelector('[data-qty-custom-toggle]').setAttribute('aria-expanded', 'false');
      apply(btn.dataset.qtyOption);
    });
  });

  var toggle = root.querySelector('[data-qty-custom-toggle]');
  toggle.addEventListener('click', function () {
    clearActive();
    toggle.classList.add('is-active');
    toggle.setAttribute('aria-pressed', 'true');
    customWrap.hidden = false;
    customInput.disabled = false;
    // Hallazgo posterior (revisión de Task 5): el input ya no trae
    // `value="1"` precargado (ver package-selector.liquid) — arranca
    // vacío siempre que se abre Custom, incluida una REAPERTURA con un
    // valor viejo adentro. Sin este reset, escribir sobre un valor ya
    // presente (el "1" original, o lo que haya quedado de una edición
    // anterior) concatena en vez de reemplazar porque `.focus()` no
    // selecciona texto — el cursor cae al final y "7" se vuelve "17".
    // `apply('')` cae a 1 paquete por la misma rama que ya cubre
    // "0"/vacío/negativo, sin lógica nueva.
    customInput.value = '';
    toggle.setAttribute('aria-expanded', 'true');
    customInput.focus();
    apply(customInput.value);
  });

  customInput.addEventListener('input', function () { apply(customInput.value); });

  apply(1);
}());

// Paginación numerada del mosaico del local (nodo 819:5621). Cuántas páginas
// hay depende de cuántos tiles entran en pantalla, y eso cambia con el ancho
// del viewport — así que no se puede resolver en Liquid: se calcula del ancho
// real de la pista y se rehace al redimensionar. El control viene [hidden]
// desde el Liquid y solo se muestra si de verdad hay más de una página; sin JS
// la pista sigue siendo scrollable/arrastrable, no se pierde ninguna foto.
(function photoMosaicPagination() {
  // 25-ago (pedido de Robert): las flechas ya no desplazan una pista con
  // scroll — ROTAN las fotos por los huecos fijos del mosaico. El hueco
  // grande es la posicion 2 (donde el master pone la caja registradora) y lo
  // pinta el CSS con :nth-child, asi que basta reordenar el DOM: con "next",
  // la primera foto pasa al final y la que estaba en el hueco 3 (la manteca)
  // entra al grande. Los numeros marcan QUE FOTO esta en el hueco grande
  // (1..N) y clicar uno rota hasta ponerla ahi. La paginacion se queda
  // alineada bajo el tercer tile (CSS), como en el master.
  document.querySelectorAll('[data-pm-pagination]').forEach(function (ui) {
    var section = ui.closest('[data-photo-mosaic]');
    var track = section && section.querySelector('[data-pm-track]');
    var pagesEl = ui.querySelector('[data-pm-pages]');
    if (!track || !pagesEl) return;

    var total = track.children.length;
    if (total < 2) return;

    // Identidad de cada foto: su posicion inicial. El "actual" es la foto que
    // ocupa el hueco grande (children[1]); con la rotacion el DOM cambia de
    // orden, asi que el indice se guarda en el propio nodo.
    Array.prototype.forEach.call(track.children, function (el, i) {
      el.setAttribute('data-pm-i', String(i));
    });
    var current = function () {
      var slot = track.children[Math.min(1, total - 1)];
      return parseInt(slot.getAttribute('data-pm-i'), 10);
    };

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var MOVIL = window.matchMedia('(max-width: 989px)');
    var animating = false;

    function aplicar(delta) {
      for (var i = 0; i < delta; i++) track.appendChild(track.firstElementChild);
      // En movil la pista sigue siendo scroll: al rotar se vuelve al arranque.
      // 'instant' porque scroll-behavior:smooth se comeria la asignacion.
      track.scrollTo({ left: 0, behavior: 'instant' });
      render();
    }

    // En movil el mosaico es una REJILLA 2x2, no una pista horizontal: el FLIP
    // de mas abajo solo anima el desplazamiento en X, asi que una foto que baja
    // de la primera fila a la segunda hacia medio recorrido sin animar y el paso
    // se veia roto. Aqui las cuatro a la vista se FUNDEN: se van, se reordena el
    // DOM, y entran escalonadas. Pedido de Robert (10-sep): "el carrusel, el
    // efecto no debe ser el mismo que en desktop".
    function rotarMovil(delta) {
      animating = true;
      var salen = Array.prototype.slice.call(track.children, 0, 4);
      if (!salen.length) { aplicar(delta); animating = false; return; }
      var pend = salen.length;
      var fuera = salen.map(function (el) {
        return el.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 160, easing: 'ease-in', fill: 'forwards'
        });
      });
      fuera.forEach(function (anim) {
        anim.onfinish = function () {
          pend--;
          if (pend) return;
          aplicar(delta);
          fuera.forEach(function (a) { a.cancel(); });
          var entran = Array.prototype.slice.call(track.children, 0, 4);
          if (!entran.length) { animating = false; return; }
          var pend2 = entran.length;
          entran.forEach(function (el, i) {
            var anim2 = el.animate([
              { opacity: 0, transform: 'translateY(10px)' },
              { opacity: 1, transform: 'none' }
            ], { duration: 260, delay: i * 45, easing: 'ease-out' });
            anim2.onfinish = function () { pend2--; if (!pend2) animating = false; };
          });
        };
      });
    }

    function rotate(delta) {
      if (animating) return;

      if (MOVIL.matches) {
        if (reduce || !track.firstElementChild.animate) { aplicar(delta); return; }
        rotarMovil(delta);
        return;
      }

      // FLIP (25-ago, pedido de Robert: "una animacion mas fluida"): se apunta
      // donde estaba cada tile, se reordena el DOM, y cada uno se anima desde
      // su posicion vieja a la nueva. El ALTO va en px dentro del keyframe
      // porque el 472/614 vive en aspect-ratio, que no es animable — asi el
      // tile que entra al hueco grande CRECE mientras se desliza, y el que
      // sale encoge. Un tile que viene del otro extremo del DOM (teletransporte
      // de la rotacion) no cruza toda la pantalla: entra desde el lado del
      // movimiento a distancia de un paso, con fundido.
      var antes = new Map();
      Array.prototype.forEach.call(track.children, function (el) {
        antes.set(el, el.getBoundingClientRect());
      });

      aplicar(delta);

      if (reduce || !track.firstElementChild.animate) return;

      var step = 0;
      if (track.children.length > 1) {
        step = track.children[1].getBoundingClientRect().left -
               track.children[0].getBoundingClientRect().left;
      }
      var dir = delta <= total / 2 ? 1 : -1; // 1 = next (entra por la derecha)

      animating = true;
      var pendientes = 0;
      Array.prototype.forEach.call(track.children, function (el, idx) {
        if (idx > 4) return; // solo la ventana visible y la primera oculta
        var despues = el.getBoundingClientRect();
        var previa = antes.get(el);
        var dx = previa ? previa.left - despues.left : 0;
        var h0 = previa ? previa.height : despues.height;
        var fundido = false;
        if (!previa || Math.abs(dx) > step * 1.6) {
          // teletransportado: que entre desde el lado natural del movimiento
          dx = dir * step;
          h0 = despues.height;
          fundido = true;
        }
        if (!dx && h0 === despues.height) return;
        pendientes++;
        var anim = el.animate([
          { transform: 'translateX(' + dx + 'px)', height: h0 + 'px', opacity: fundido ? 0 : 1 },
          { transform: 'none', height: despues.height + 'px', opacity: 1 }
        ], { duration: 480, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' });
        anim.onfinish = function () {
          pendientes--;
          if (!pendientes) animating = false;
        };
      });
      if (!pendientes) animating = false;
    }

    function goTo(fotoIdx) {
      rotate((fotoIdx - current() + total) % total);
    }

    // El master ensena tres numeros, una elipsis y la ultima pagina.
    function window_() {
      if (total <= 4) {
        return Array.apply(null, { length: total }).map(function (_, i) { return i; });
      }
      var cur = current();
      var start = Math.min(Math.max(0, cur - 1), total - 4);
      return [start, start + 1, start + 2, 'gap', total - 1];
    }

    function render() {
      ui.hidden = total < 2;
      if (ui.hidden) return;
      var cur = current();
      pagesEl.textContent = '';
      window_().forEach(function (item) {
        if (item === 'gap') {
          var dots = document.createElement('span');
          dots.className = 'photo-mosaic__ellipsis';
          dots.setAttribute('aria-hidden', 'true');
          dots.textContent = '…';
          pagesEl.appendChild(dots);
          return;
        }
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'photo-mosaic__page' + (item === cur ? ' is-active' : '');
        b.textContent = String(item + 1);
        if (item === cur) b.setAttribute('aria-current', 'true');
        b.addEventListener('click', function () { goTo(item); });
        pagesEl.appendChild(b);
      });
    }

    ui.querySelector('[data-pm-prev]').addEventListener('click', function () {
      rotate(total - 1);
    });
    ui.querySelector('[data-pm-next]').addEventListener('click', function () {
      rotate(1);
    });

    render();
  });
}());

/* ============================================================
   Our Production — los 7 banners del Figma, pasando solos
   ============================================================
   El Figma trae siete versiones de la misma banda (una por producto de la
   casa) y Robert pidió que fueran pasando. El markup las imprime todas
   apiladas en la misma celda de grid; aquí solo se mueve `.is-active`, el
   crossfade lo hace el CSS.

   Carga diferida propia: salvo el primero, cada banner lleva su foto en
   `data-src` con un GIF de 1x1 en el `src`. Se promueven el actual y el
   SIGUIENTE — y no antes de que la sección entre en pantalla. Sin esto se
   descargaban ~440KB de fotos nada más abrir la home.
   Desde el 3-sep, con el salto a 2 segundos, en cuanto la banda asoma se cargan
   las SIETE de golpe: a esa velocidad ir una por delante no da margen, y la
   vuelta entera dura 14 s, así que se acaban viendo todas de todos modos.

   Se para con el puntero encima o el foco dentro (para no cambiar el banner
   que alguien está leyendo) y fuera de pantalla.
   Sin puntos desde el 26-ago (Robert: "que pasen solos y ya"), así que el paso
   automático es el ÚNICO modo de ver los siete. */
(function () {
  document.querySelectorAll('[data-op-rotator]').forEach(function (root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-op-slide]'));
    if (slides.length < 2) return;

    var current = 0;
    var paused = false;
    var onScreen = false;

    function load(n) {
      var img = slides[n] && slides[n].querySelector('img[data-src]');
      if (!img) return;
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    }

    function go(n) {
      var next = (n + slides.length) % slides.length;
      if (next === current) return;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = next;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      load(current);
      load((current + 1) % slides.length);
    }

    ['pointerenter', 'focusin'].forEach(function (evt) {
      root.addEventListener(evt, function () { paused = true; });
    });
    ['pointerleave', 'focusout'].forEach(function (evt) {
      root.addEventListener(evt, function () { paused = false; });
    });

    /* Al entrar en pantalla se cargan TODAS, no solo la siguiente (3-sep). Con
       6 segundos entre saltos bastaba con ir una por delante; a 2 el margen se
       queda corto y el fundido puede pillar la foto a medio bajar. Y el motivo
       original para diferirlas —"la mayoría de visitantes no llega a ver el
       resto"— ya no se sostiene: la vuelta entera dura 14 s, así que quien mire
       la banda las va a ver todas igualmente.
       Lo que SÍ se conserva es lo importante: hasta que la sección no asoma no
       se descarga ni un byte. */
    function loadAll() {
      for (var i = 0; i < slides.length; i++) load(i);
    }

    if (typeof IntersectionObserver === 'function') {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) loadAll();
      }, { threshold: 0.25 }).observe(root);
    } else {
      onScreen = true;
      loadAll();
    }

    /* Con prefers-reduced-motion NO se corta la rotación: sin puntos, pararla
       dejaría seis de los siete banners sin forma de verse. El CSS ya baja el
       crossfade a 0.01ms en ese modo, así que el cambio es instantáneo — hay
       relevo de contenido, pero no animación. */
    /* 2 segundos por banner (Robert, 3-sep; antes eran 6). Con los siete, la
       vuelta completa dura 14 s. El fundido del CSS son 0.6 s, así que cada
       banner se está quieto 1.4 s — quien quiera leer uno tiene el pausado por
       hover/foco, que ya estaba. */
    setInterval(function () {
      if (paused || !onScreen) return;
      go(current + 1);
    }, 2000);
  });
}());
